export const SESSION_INFORMATION_DATE_FORMAT = 'dd-MMM-yyyy HH:mm';
